// Copyright (c) StrangeBee 2023

import { classList } from '@Helpers/className';
import { Radio, RadioGroupProps } from 'antd';
import React, { ReactElement } from 'react';

import './Group.scss';

type GroupProps = RadioGroupProps;

export const Group = ({ className, children, ...props }: GroupProps): ReactElement => (
    <Radio.Group className={classList('th-radio__group', className)} {...props}>
        {children}
    </Radio.Group>
);
